"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isId(input) {
    return typeof input === "string" && /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(input);
}
exports.default = isId;
